import { makeStyles } from '@material-ui/core';
import { colorSet } from '@components/Provider';

export const useStylesDialogOption = makeStyles((theme) => ({
  root: {
    '& .MuiDialog-container': {
      '& .MuiPaper-root': {
        overflow: 'scroll'
      }
    }
  },
  paper: {
    width: '100%',
    maxWidth: '496px',
    minWidth: '420px',
    maxHeight: '674px',
    overflowY: 'hidden',
    '& .viewer': {
      borderRight: `solid 1px ${colorSet.backgroundBase}`
    }
  },
  header: {
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${colorSet.backgroundBase}`,
    padding: '16px 20px',
    fontSize: 16,
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: {
    padding: '12px 27px',
    backgroundColor: colorSet.primary200,
    '& b': {
      fontSize: 16
    }
  },
  content: {
    padding: '20px',
    maxHeight: 'calc(652px - 180px)',
    overflowY: 'auto',
    '& .placeholder': {
      color: theme.palette.text.secondary
    }
  },
  inputFlexBox: {
    display: 'flex',
    marginBottom: 8,
    '& .MuiOutlinedInput-root': {
      height: 42
    }
  },
  inputColumnBox: {
    display: 'flex',
    flexDirection: 'column'
  },
  inputLabel: {
    fontWeight: 500,
    minWidth: '90px',
    marginRight: '14px',
    color: colorSet.primary1000,
    lineHeight: '40px',
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    }
  },
  attributes_subtext: {
    fontSize: 12,
    color: colorSet.gray600,
    lineHeight: '40px',
    marginBottom: '-16px'
  },
  inputRoot: {
    '& input, textarea': {
      fontSize: 14,
      wordBreak: 'keep-all'
    }
  },
  action: {
    padding: '20px 80px',
    borderTop: `solid 1px ${colorSet.backgroundBase}`,
    justifyContent: 'center'
  },
  selectRoot: {
    fontSize: 14,
    padding: '10px 12px',
    '&$disabled': { backgroundColor: colorSet.backgroundLight }
  },
  inputDetail: {
    '& input, textarea': {
      fontSize: 14,
      height: 100,
      wordBreak: 'keep-all'
    }
  },
  disabled: {},

  menuItem: {
    fontSize: 14
  },
  recommendRoot: {
    backgroundColor: colorSet.warningLight,
    borderRadius: 4,
    padding: '16px !important',
    marginTop: 12,
    '& .MuiBox-root': {
      justifyContent: 'flex-start'
    }
  },
  recommendTitle: {
    ...theme.typography.body1,
    fontWeight: 500,
    color: colorSet.gray900
  },
  recommendSubtitle: {
    color: colorSet.gray600,
    ...theme.typography.body2,
    fontWeight: 400
  },
  recommendChip: {
    ...theme.typography.caption,
    fontWeight: 400,
    color: colorSet.gray600,
    backgroundColor: colorSet.gray000,
    borderRadius: 30,
    margin: '8px 2px',
    border: `1px solid ${colorSet.gray200}`,
    '&:focus': {
      backgroundColor: colorSet.gray000,
      color: colorSet.gray600
    },
    '&:hover': {
      backgroundColor: colorSet.primary500,
      color: colorSet.gray000
    }
  },
  recommendChipActive: {
    backgroundColor: colorSet.primary500,
    ...theme.typography.caption,
    fontWeight: 400,
    color: colorSet.gray000,
    borderRadius: 30,
    margin: '8px 2px',
    '&:hover': {
      backgroundColor: colorSet.primary500,
      color: colorSet.gray000
    }
  },
  helperTextGray: {
    ...theme.typography.caption,
    fontWeight: 400,
    color: colorSet.gray600,
    width: '100%',
    padding: 8
  },
  helperTextRed: {
    ...theme.typography.caption,
    fontWeight: 400,
    color: colorSet.errorMain,
    width: '100%',
    padding: 8
  },
  textfield: {
    '& .MuiInputBase-root': {
      height: 42
    }
  }
}));
